import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const scorecardRulesStatusSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardRulesStatus: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARD_RULES_STATUS,
                    params: { year, month, scorecardVersionId },
                };
            },
        }),
    }),
});

export const { useGetScorecardRulesStatusQuery } = scorecardRulesStatusSlice;
